import { css } from '@emotion/react';

const styles = css`
  padding-bottom: var(--cds-spacing-50);
`;

export default styles;
